import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@check-list/environments/environment';
import { Email } from '@authority-labs/api-interfaces';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EmailsService {
  private api = `${environment.API}/emails`;

  constructor(private http: HttpClient) {}

  sendEmail(email: Email): Observable<void> {
    return this.http.post<Partial<void>>(this.api, email);
  }
}
